var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkTask1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 2.49993C13.3852 2.86047 14.0502 2.99994 14.3388 4.23796C14.4905 4.88848 14.2891 5.64017 13.8862 7.14356L13.5412 8.43146C13.1383 9.93485 12.9369 10.6865 12.4803 11.1741C12.1198 11.559 11.6532 11.8284 11.1395 11.9482C11.0753 11.9631 11.0102 11.9746 10.9434 11.9829C10.3334 12.0581 9.58899 11.8587 8.23393 11.4956C6.73054 11.0928 5.97885 10.8913 5.49133 10.4347C5.10638 10.0742 4.837 9.6076 4.71723 9.09396C4.56555 8.44344 4.76697 7.69175 5.1698 6.18836L5.51489 4.90046C5.57283 4.68425 5.62659 4.48358 5.67755 4.29702C5.98094 3.18632 6.18481 2.57526 6.57576 2.15785C7.50024 1.1708 8.50024 1.49996 8.50024 1.49996",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91987 1.12617C9.03572 0.737133 9.4819 0.526652 9.91643 0.656051L12.5391 1.43704C12.9736 1.56644 13.2319 1.98672 13.1161 2.37576L12.9762 2.84538C12.8604 3.23442 12.4142 3.4449 11.9797 3.3155L9.35704 2.53451C8.92251 2.40511 8.66417 1.98483 8.78002 1.59579L8.91987 1.12617Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 11.9827C10.8043 12.4084 10.5598 12.7935 10.2312 13.1012C9.74371 13.5579 8.99201 13.7593 7.48863 14.1621C5.98524 14.5649 5.23354 14.7664 4.58303 14.6147C4.06939 14.4949 3.6028 14.2255 3.24226 13.8406C2.78564 13.3531 2.58423 12.6014 2.1814 11.098L1.83631 9.81008C1.43347 8.30669 1.23206 7.555 1.38374 6.90448C1.5035 6.39084 1.77289 5.92425 2.15783 5.56372C2.64535 5.1071 3.39705 4.90568 4.90043 4.50285C5.18486 4.42664 5.44237 4.35764 5.67739 4.29688",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34106 6.62976L11.041 7.76378",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70581 8.73145L8.61778 9.31827",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkTask1);
export default __webpack_public_path__ + "static/media/bulkTask1.4691b0179f10ea8918bf381a87f992f3.svg";
export { ForwardRef as ReactComponent };